/* eslint-disable no-useless-concat */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import "./SharedModalComponent.css";
import React, { Fragment, useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
// import Chip from "@mui/material/Chip";
// import Paper from "@mui/material/Paper";
import {
  Button,
  FormControl,
  Input,
  InputAdornment,
  // InputLabel,
  Modal,
} from "@mui/material";
import Box from "@mui/material/Box";
// import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import UpdatePropertyStatus from "../../../../controllers/properties/UpdatePropertyStatus";
import SinglePropertyContent from "../SinglePropertyContent/SinglePropertyContent";
// import ListBox from "./ListBox/ListBox";
// import GetAllClients from "../../../../controllers/clients/GetAllClients";
import {
  getLocalStorage,
  getLocalStorageItem,
} from "../../../../controllers/localStorage/getLocalStorage";
import {
  // client,
  QueryTypesense,
} from "../../../../Typesense";
import SearchIcon from "@mui/icons-material/Search";
import { stringAvatar } from "../../../../helpers/stringAvatar";
import { Avatar } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../../../firebase";
import addNotification from "../../../../controllers/notifications/store_notification";
// Modal Start
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  border: "2px solid #cccccc",
  boxShadow: 24,
  p: 4,
  borderRadius: "5px",
};
// Modal End

const ListItem = styled("li")(({ theme }) => ({
  margin: theme.spacing(0.5),
}));
let allClientsData;
const SharedModalComponent = ({
  OpenModal,
  handleCloseDetailModal,
  propertyID,
  property,
}) => {
  const [PropertyStatus, setPropertyStatus] = useState("");
  const [status, setStatus] = useState("");
  const [IsPublic, setIsPublic] = useState(false);
  const [SharedParties, setSharedParties] = useState([]);
  const [DisableButton, setDisableButton] = useState(false);
  const [ButtonText, setButtonText] = useState("Select");
  const [Loader, setLoader] = useState(false);

  useEffect(() => {
    let tempArray = [];
    if (
      property?.sharedParties !== [] &&
      property?.sharedParties !== undefined &&
      property?.sharedParties !== null
    ) {
      setStatus(property.status);
      if (status === "public") {
        setIsPublic(true);
      } else {
        setIsPublic(false);
      }
      tempArray = property?.sharedParties.map((party) => {
        if (typeof party == typeof {}) {
          return party.id;
        } else {
          return party;
        }
      });

      setSharedParties([...tempArray]);
    }
  }, [property, handleCloseDetailModal, OpenModal]);

  useEffect(() => {
    let noOfParties = SharedParties?.length;

    if (noOfParties > 0) {
      let sRef = status;
      sRef = "shared";
      setStatus(sRef);
    }
  }, [SharedParties]);

  useEffect(() => {
    if (IsPublic === true) {
      setStatus("public");
      setSharedParties([]);
    } else {
      let sRef = status;
      sRef = "inventory";
      setStatus(sRef);
      setSharedParties([]);
    }
  }, [IsPublic]);
  const handleClickSharedParty = (id) => {
    const index = SharedParties.findIndex(checkid);
    function checkid(ID) {
      return id === ID;
    }

    if (index === -1) {
      SharedParties.push(id);
      setSharedParties([...SharedParties]);
    } else {
      if (SharedParties.length === 1) {
        SharedParties.pop(id);
      } else {
        SharedParties.splice(index, 1);
      }

      setSharedParties([...SharedParties]);
    }
  };

  const NUMBER_OF_SHARED_PARTIES = SharedParties.length;

  const handleDelete = (chipToDelete) => () => {
    setSharedParties((chips) => chips.filter((chip) => chip !== chipToDelete));
  };

  const handleAddChip = (chipToAdd) => () => {
    setSharedParties((current) => [...current, chipToAdd]);
  };

  const [SearchText, setSearchText] = useState("");

  /** Search Query */
  const [Result, setResult] = useState([]);

  //   // async function fetchData() {
  //   //   if (SearchText === "") {
  //   //     setResult(null);
  //   //     return;
  //   //   }
  //   //   //console.log("Query ...");
  //   //   let result = {};
  //   //   /** users data */
  //   //   result.clients = (
  //   //     await QueryTypesense(
  //   //       {
  //   //         q: SearchText,
  //   //         query_by: "businessName",
  //   //       },
  //   //       "clients"
  //   //     )
  //   //   ).map(({ document }) => document);
  //   //   result.firstFewClients = (
  //   //     await QueryTypesense(
  //   //       {
  //   //         page: 1,
  //   //         per_page: 8,
  //   //         q: SearchText,
  //   //         query_by: "businessName",
  //   //       },
  //   //       "clients"
  //   //     )
  //   //   ).map(({ document }) => document);
  //   //   setResult([...result.clients, ...result.firstFewClients]);
  //   // }
  //   // fetchData();

  // }, [SearchText]);

  // useEffect(() => //console.log("Result", Result), [Result]);

  // All Clients UseEffect Start

  const [FirstFewClients, setFirstFewClients] = useState([]);
  useEffect(() => {
    async function fetchClientsTypsense() {
      const firstFewClients = (
        await QueryTypesense(
          {
            page: 1,
            per_page: 20,
            q: SearchText,
            query_by: "businessName",
          },
          "clients"
        )
      )
        .map(({ document }) => document)
        .filter(({ businessName }) => businessName !== "")
        .filter(({ id: bid }) => getLocalStorageItem("bid") !== bid);

      setResult(firstFewClients);
    }

    const fetchClientsFirestore = async () => {
      try {
        const clientsCollection = collection(db, "clients");
        const q = query(clientsCollection, where("businessName", "!=", ""));
        const clientSnapshot = await getDocs(q);
        let allClients = [];
        clientSnapshot.forEach((e) =>
          allClients.push({ ...e.data(), id: e.id })
        );

        const filteredclients = allClients.filter(({ id }) => {
          return id !== getLocalStorageItem("bid");
        });
        allClientsData = filteredclients;

        setResult(filteredclients);
      } catch (error) {
        console.log(error);
      }
    };

    fetchClientsTypsense();
  }, [SearchText]);
  // All Clients UseEffect End

  const Clients = Result?.clients;
  const ClientDocument =
    Clients &&
    Clients.map((client) => {
      return client.document;
    });

  const handleUpdatePropertyStatus = async () => {
    let pstatus = status;
    if (SharedParties.length === 0 && status === "shared") {
      pstatus = "inventory";
    }
    setLoader(true);
    await UpdatePropertyStatus(
      propertyID,
      SharedParties,
      NUMBER_OF_SHARED_PARTIES,
      pstatus
    );
    let businessName = "";
    try {
      const userRef = query(doc(db, "clients", property.bid));
      const userSnapshot = await getDoc(userRef);
      businessName = userSnapshot.data().businessName;
    } catch (error) {
      console.log(error);
    }

    for (let i = 0; i < SharedParties.length; i++) {
      const title =
        businessName + " Shared a " + property.propertySubType + " with you!";
      const description =
        businessName + " Shared a " + property.propertySubType + " with you!";
      const notification_type = "Shared";
      const notification_link =
        "https://app.landbook.pk" +
        "/user/properties/inventory/details/" +
        propertyID;
      const record_id = propertyID;
      const receiver_id = SharedParties[i];
      const is_seen = false;
      const is_deleted = false;
      const image = "";
      await addNotification(
        title,
        description,
        notification_type,
        image,
        notification_link,
        record_id,
        receiver_id,
        is_seen,
        is_deleted
      );
    }
    handleCloseDetailModal();
    setLoader(false);
  };

  const submitShareForm = () => {};

  return (
    <Fragment>
      {/* Modal Start */}
      <div>
        <Modal
          open={OpenModal}
          onClose={handleCloseDetailModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="property-share-modal-container"
        >
          <Box sx={style}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: "10px",
                marginLeft: "20px",
                marginRight: "20px",
              }}
            >
              <div style={{ height: "34px" }}>
                <p
                  // style={{
                  //   fontSize: "20px",
                  //   fontWeight: 600,
                  //   fontFamily: "Poppins",
                  // }}

                  className="modal-heading"
                >
                  Share Property
                </p>
              </div>

              <span
                onClick={handleCloseDetailModal}
                style={{ cursor: "pointer", opacity: 0.5 }}
              >
                <CloseIcon />
              </span>
            </div>

            <div className="top-heading">
              <div className="property-status-select"></div>

              {/* <p>Share Property</p> */}
            </div>

            <div style={{ paddingLeft: "20px", paddingRight: "20px" }}>
              <hr className="hr m-0 my-2" />
              <Fragment>
                <SinglePropertyContent
                  style={{
                    border: "1px solid #4e36a8",
                    marginTop: 30,
                  }}
                  propertyID={propertyID}
                  propertyDetailsPropertyContent={
                    "propertyDetailsPropertyContent"
                  }
                  flag={false}
                />
              </Fragment>
            </div>

            <Fragment>
              {/* </Paper> */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: "5px",
                  marginLeft: "20px",
                  marginRight: "20px",
                  marginBottom: "5px",
                }}
              >
                <div>
                  <p
                    style={{
                      fontSize: "13px",
                      color: "#7989A2",
                      marginBottom: "0",
                    }}
                  >
                    Share with (
                    {IsPublic ? "All" : `${SharedParties.length} Selected`})
                  </p>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                  }}
                >
                  <p
                    style={{
                      margin: "0px 7px 0px 8px",
                      color: "var(--theme-color)",
                      fontWeight: "500",
                    }}
                  >
                    Public
                  </p>
                  <input
                    style={{
                      cursor: "pointer",
                      fontSize: "14px",
                      color: "#4C3CA6",
                      accentColor: "var(--theme-color)",
                    }}
                    type="checkbox"
                    defaultChecked={IsPublic}
                    onChange={(e) => {
                      setIsPublic((isP) => {
                        return !isP;
                      });
                    }}
                  />
                </div>
              </div>

              <FormControl
                variant="standard"
                fullWidth
                className="share-container"
              >
                <Input
                  disabled={IsPublic}
                  startAdornment={
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  }
                  id="component-simple"
                  placeholder="Search For Dealers"
                  style={{
                    color: "#4e36a8",
                    backgroundColor: "#F8F8F8",
                    height: "40px",
                    border: "0",
                    padding: "5px",
                    paddingLeft: "10px",
                    borderLeft: "0",
                    borderRight: "0",

                    marginLeft: "20px",
                    marginRight: "20px",
                    outline: "0",
                    fontSize: "14px",
                  }}
                  onBlur={(e) => {
                    if (e.target.value === "") {
                      setSearchText("");
                    }
                  }}
                  onChange={(e) => setSearchText(e.target.value)}
                />

                <div
                  style={{
                    height: 248,
                    overflowX: "hidden",
                    overflowY: "auto",
                    paddingTop: 10,
                    paddingBottom: 10,
                  }}
                >
                  {Result &&
                    Result.map(({ businessName, id, image_url }) => (
                      <div
                        className={`${IsPublic ? "disabledbutton" : ""}`}
                        key={id}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            // marginTop: "5px",
                            paddingLeft: "20px",
                            paddingRight: "20px",
                            // marginBottom: "5px",
                            paddingTop: 4,
                            paddingBottom: 4,
                            cursor: "pointer",
                          }}
                          className={"sharePartyInListing"}
                          onClick={() => {
                            if (!IsPublic) {
                              handleClickSharedParty(id);
                            }
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            {image_url ? (
                              <div
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  borderRadius: "50%",
                                  backgroundImage: `url(${image_url})`,
                                  backgroundPosition: "center",
                                  backgroundSize: "cover",
                                  backgroundRepeat: "no-repeat",
                                }}
                              ></div>
                            ) : (
                              <Avatar
                                {...stringAvatar(businessName)}
                                className="AgentAvatar"
                              />
                            )}

                            <h5
                              style={{
                                fontSize: "14px",
                                fontWeight: "600",
                                marginTop: "5px",
                                marginLeft: "15px",
                              }}
                            >
                              {businessName}
                            </h5>
                          </div>
                          <div>
                            <input
                              disabled={IsPublic}
                              style={{
                                cursor: "pointer",
                                fontSize: "14px",
                                color: "#4C3CA6",
                              }}
                              type="checkbox"
                              // disabled={IsPublic}
                              checked={
                                SharedParties.includes(id) ? true : false
                              }
                            />
                          </div>
                        </div>
                        <div
                          style={{
                            marginLeft: "20px",
                            marginRight: "20px",
                          }}
                        >
                          <hr className="hr m-0 my-2" id="bottom-line" />
                        </div>
                      </div>
                    ))}
                </div>
              </FormControl>
            </Fragment>

            <div
              style={{
                display: "flex",
                alignItems: "right",
                justifyContent: "right",
              }}
            >
              <div>
                <Button
                  style={{
                    color: "#ffffff",
                    backgroundColor: "var(--theme-color)",
                    fontSize: "12px",
                    width: 550,
                    height: 50,
                  }}
                  onClick={handleUpdatePropertyStatus}
                  className="btn-right"
                  disabled={Loader}
                >
                  {Loader && (
                    <span className="spinner-border spinner-border-sm mr-1"></span>
                  )}{" "}
                  Share
                </Button>
              </div>
            </div>
          </Box>
        </Modal>
      </div>
      {/* Modal End */}
    </Fragment>
  );
};
export default SharedModalComponent;
